import React from "react"

interface ISpinner {
  backgroundColor?: string
  primaryColor?: string
  size?: string
}

export function Spinner({
  primaryColor,
  size = "25",
  backgroundColor = "rgb(255, 255, 255)",
}: ISpinner) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      style={{ shapeRendering: "auto", display: "block", background: backgroundColor }}
      width={size || "25"}
      height={size || "25"}
    >
      <g>
        <circle
          strokeDasharray="164.93361431346415 56.97787143782138"
          r="35"
          strokeWidth="10"
          stroke={primaryColor || "#e15b64"}
          fill="none"
          cy="50"
          cx="50"
        >
          <animateTransform
            keyTimes="0;1"
            values="0 50 50;360 50 50"
            dur="1s"
            repeatCount="indefinite"
            type="rotate"
            attributeName="transform"
          ></animateTransform>
        </circle>
        <g></g>
      </g>
    </svg>
  )
}
